import { capitalize } from "@/utils/string";
import { Image, Typography } from "@backpac/monica";

// This is a temp workaround in terms of getting the platform logo (Untrusted CDN?)
const PLATFORM_CDN_MAP = {
  meta: "https://cdn.simpleicons.org/facebook",
  spotify: "https://cdn.simpleicons.org/spotify",
  apple: "https://cdn.simpleicons.org/apple",
  google: "https://cdn.simpleicons.org/youtube",
  youtube: "https://cdn.simpleicons.org/youtube",
  tidal: "https://cdn.simpleicons.org/tidal",
  tiktok: "https://cdn.simpleicons.org/tiktok",
  amazon: "https://cdn.simpleicons.org/amazon",
} as const;

type PlatformKeys = keyof typeof PLATFORM_CDN_MAP;
export const PLATFORM_MAP = {
  FACEBOOK: "meta",
  TIKTOK: "tiktok",
  "YOUTUBE SHORTS": "youtube",
  "APPLE MUSIC": "apple",
  "AMAZON UNLIMITED (USD)": "amazon",
  SPOTIFY: "spotify",
} satisfies Record<string, PlatformKeys>;

export const getPlatformName = (platform: string) => {
  return capitalize(PLATFORM_MAP[platform.toUpperCase() as keyof typeof PLATFORM_MAP] ?? platform);
};

const getPlatformImgUrl = (platform: string) => {
  // @ts-expect-error ignored
  const target = PLATFORM_MAP[platform.toUpperCase()];
  if (target == null) {
    return null;
  }
  return PLATFORM_CDN_MAP[target as PlatformKeys];
};

export const PlatformFlag = ({ platform }: { platform: string }) => {
  const imageUrl = getPlatformImgUrl(platform);
  return (
    <div className="flex flex-row items-center gap-1">
      <Typography size="xs" color="textPrimary">
        {getPlatformName(platform)}
      </Typography>
      {imageUrl && <Image src={imageUrl} width="15px" className="border border-1" alt={platform} />}
    </div>
  );
};
